var browserSupport = require('./browserSupport');

if (!browserSupport.canRunShowroom()) {
    window.onerror = function () {
        return true; // prevent default event handler //
    };
    document.write('<script src="/upgradebrowser.js?_' + Math.round(Math.random() * 1000000) + '"></sc' + 'ript>');
}




//////////////////
// WEBPACK FOOTER
// ./bootstrapBrowserCheck.js
// module id = 0
// module chunks = 1